<script setup lang="ts">
defineProps<{
  visible: boolean
}>()
</script>

<template>
  <div
    v-show="visible"
    class="pointer-events-none absolute z-10 border-t border-dashed border-primal/60"
  />
</template>
